export function iif(condition: boolean, trueValue: any, falseValue?: any) {
    if (condition) {
        return typeof (trueValue) === "function"
            ? trueValue()
            : trueValue;
    } else {
        return typeof (falseValue) === "function"
            ? falseValue()
            : falseValue;
    }
}